module.exports = __webpack_public_path__ + "img/3.bee276ef.jpg";